import type { CellStyle } from 'ag-grid-community';

export const CELL_RENDERERS = {
  TEXT: 'textRenderer'
};
export const ROW_SELECTION_MULTIPLE = 'multiple';

export const TABLE_LAYOUT = {
  NORMAL: 'normal'
};

export const TABLE_STYLES = {
  width: '100%',
  height: 'calc(100vh - 230px)',
  rowHeight: 32
};

export const COMPONENT_MAIN_CLASS = 'cdk-rds-table';

export const AG_GRID_THEME_CLASS = 'ag-theme-balham';

export const DEFAULT_CELL_STYLE: CellStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'block'
};

export const PRINT_EXPORT_MAX_INVOICES = 15000;

export const HIDE_TABLE_BORDER_CLASS = 'hide-table-border';
